/**
 * How a product feature is PRESENTED — not whether it is on.
 *
 * These are deliberately separate from `../feature-flags`. That file answers "is this feature enabled?" and
 * is owned by PostHog. This one answers "what should a user be told about it?" and is owned by an operator in
 * the admin dashboard. Putting a kill switch and a badge behind the same control would mean turning off a
 * feature to stop calling it new.
 */

/** Mirrors Prisma `PlatformFeatureNewMode`. When — and for whom — the "New" badge stops showing. */
export enum ProductFeatureNewMode {
  /** No "New" badge. */
  Off = "OFF",
  /**
   * Clears for a user once they have opened the feature. `newUntil`, when set, still stops it for everyone
   * on that date — so a badge nobody ever clicked does not last forever.
   */
  UntilSeen = "UNTIL_SEEN",
  /** Everyone sees it until `newUntil`, whether or not they looked. Requires `newUntil`. */
  UntilDate = "UNTIL_DATE",
}

/** Mirrors Prisma `PlatformFeatureVideoProvider`. Decides how the tutorial is embedded. */
export enum ProductFeatureVideoProvider {
  YouTube = "YOUTUBE",
  Vimeo = "VIMEO",
  /** A direct video file (mp4/webm), played by the browser rather than embedded in a frame. */
  File = "FILE",
}

/**
 * The one badge a feature shows, already decided by the server.
 *
 * A feature can be both new and unfinished, but a nav row has room for one word. "New" wins while it is
 * live and the feature falls back to "Beta" afterwards — so nothing has to be un-set by hand on release day.
 */
export enum ProductFeatureBadge {
  New = "NEW",
  Beta = "BETA",
}
